import RelationshipTypePanel from "./panels/RelationshipTypePanel";


const tabRoutes = [
  {
    name: "Relationship Types",
    path: "/relationship-type",
    component: <RelationshipTypePanel />
  }
  // {
  //   name: "Deals",
  //   path: "/deals",
  //   component: <DealsPanel />,
  // },
  // {
  //   name: "Offers",
  //   path: "/offers",
  //   component: <OffersPanel />,
  // },
];

export default tabRoutes;

